import React from 'react'

interface SvgProps {
  className?: string
}
const ChatAppUnpack: React.FC<SvgProps> = ({ className }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 8L10 12L14 8" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
const ChatAppOff: React.FC<SvgProps> = ({ className }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 14L12 10L8 6" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
const ChatAppMore: React.FC<SvgProps> = ({ className }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 8L10 12L14 8" stroke="#7587A5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
const ChatAppHisIcon: React.FC<SvgProps> = ({ className }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="7" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 7V10L12 11.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
const ChatAppAiIcon: React.FC<SvgProps> = ({ className }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 9L8 11" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 9L12 11" stroke="black" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M13 4H15C16.1046 4 17 4.89543 17 6V14C17 15.1046 16.1046 16 15 16H9M8.5 2L10 4H5C3.89543 4 3 4.89543 3 6V14C3 15.1046 3.89543 16 5 16H6"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const ChatAppSvgIcon1 = () => (
  <svg width="20" height="20" className="rounded-sm" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_6762_44910)">
      <rect width="20" height="20" rx="3.33333" fill="#9333E9" />
      <path d="M7.77783 6.66602H12.7778" stroke="white" strokeWidth="1.66667" strokeLinecap="round" />
      <path d="M7.77783 13.334H12.7778" stroke="white" strokeWidth="1.66667" strokeLinecap="round" />
      <path d="M5.27783 10H15.2778" stroke="white" strokeWidth="1.66667" strokeLinecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_6762_44910">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const ChatAppSvgIcon2 = () => (
  <svg width="20" height="20" className="rounded-sm" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_6762_44919)">
      <rect width="20" height="20" rx="3.33333" fill="#F59E0C" />
      <path d="M7.5 6.66602H12.5" stroke="white" strokeWidth="1.66667" strokeLinecap="round" />
      <path d="M7.5 13.332H12.5" stroke="white" strokeWidth="1.66667" strokeLinecap="round" />
      <path d="M5 10H15" stroke="white" strokeWidth="1.66667" strokeLinecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_6762_44919">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const ChatAppSvgIcon3 = () => (
  <svg width="20" height="20" className="rounded-sm" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_6762_44926)">
      <rect width="20" height="20" rx="3.33333" fill="#15B8A6" />
      <path d="M7.77783 6.66602H12.7778" stroke="white" strokeWidth="1.66667" strokeLinecap="round" />
      <path d="M7.77783 13.334H12.7778" stroke="white" strokeWidth="1.66667" strokeLinecap="round" />
      <path d="M5.27783 10H15.2778" stroke="white" strokeWidth="1.66667" strokeLinecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_6762_44926">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export {
  ChatAppAiIcon,
  ChatAppHisIcon,
  ChatAppMore,
  ChatAppOff,
  ChatAppSvgIcon1,
  ChatAppSvgIcon2,
  ChatAppSvgIcon3,
  ChatAppUnpack
}
